import { useTranslation } from "react-i18next";
import type { PlatformTypeName } from "@multi-chat/shared";
import { cn } from "../../lib/utils.js";
import { ChannelIcon } from "./ChannelIcon.js";
import {
  channelBadgeClassName,
  channelLabelI18nKey,
} from "./channel-presentation.js";

export const CHANNEL_BADGE_SIZE_CLASS = "size-[15px]";
export const CHANNEL_BADGE_OFFSET_CLASS = "end-[-5px] bottom-[-5px]";
export const CHANNEL_BADGE_GLYPH_PX = 10;

export function ChannelBadge({
  platformType,
  className,
}: {
  platformType: PlatformTypeName;
  className?: string;
}): React.JSX.Element {
  const { t } = useTranslation();
  const label = t(`channel.${channelLabelI18nKey(platformType)}`);

  return (
    <span
      className={cn(
        "pointer-events-none absolute z-10 inline-grid place-items-center rounded-full",
        CHANNEL_BADGE_SIZE_CLASS,
        CHANNEL_BADGE_OFFSET_CLASS,

        // Heyy-style: very thin white separation from avatar
        "ring-1 ring-white",

        channelBadgeClassName(platformType),
        className,
      )}
      title={label}
      aria-label={label}
    >
      <ChannelIcon
        platformType={platformType}
        size={CHANNEL_BADGE_GLYPH_PX}
        className="text-white"
      />
    </span>
  );
}